import { z } from 'zod';
import {
  DiscountOfferType,
  DiscountPackage,
  DiscountStatus,
} from 'store/discounts';
import { UploadedFile } from 'store/files';
import { Translations } from 'types/Common';
import { ShopItemCategory } from 'types/MarketplaceItems';
import { FrequencyUnit } from 'types/general';
import { adminDiscountsFiltersSchema } from './admin-discounts.schemas';

export type AdminDiscountTranslations = Translations<{
  title: string;
  teaser: string;
  description: string;
  promo: string;
  attachments: UploadedFile[];
}>;

export const discountPublishStatuses = ['published', 'unpublished'] as const;
export type DiscountPublishStatus = (typeof discountPublishStatuses)[number];

export interface BaseAdminDiscount {
  id: string;
  name: string;
  supplier: {
    id: string;
    name: string;
    logo: UploadedFile | null;
    contact: string;
  } | null;
  priority: number;
  validTo: string | null;
  status: DiscountStatus;
  publishStatus: DiscountPublishStatus;
  viewsCount: number;
  uniqueViewsCount: number;
  favoritesCount: number;
  packages: DiscountPackage[];
}

export interface AdminDiscount extends BaseAdminDiscount {
  countries: string[];
  cities: string[];
  categories: ShopItemCategory[];
  comment: string;
  validFrom: string | null;
  createdAt: string;
  supplierContact: string;
  isSupplierContactPublic: boolean;
  code: string;
  link: string;
  companies: string[];
  codeImage: UploadedFile | null;
  image: UploadedFile | null;
  isUniqueCode: boolean;
  revealFrequencyLimit: FrequencyUnit | 'none';
  searchTags: string;
  showCurrentTime: boolean;
  publishedAt: string | null;
  translations: AdminDiscountTranslations;
  type: DiscountOfferType | null;
  discountedPercentage: number | null;
  discountedFixed: number | null;
  currency: string | null;
  averageBasketSize: number | null;
  averageSaving: number | null;
}

export type AdminDiscountsFilters = z.infer<typeof adminDiscountsFiltersSchema>;
